import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Recipe from "@/pages/Recipe";
import Cook from "@/pages/Cook";
import AddRecipe from "@/pages/AddRecipe";
import Menus from "@/pages/Menus";
import MenuDetail from "@/pages/MenuDetail";
import Gallery from "@/pages/Gallery";
import Admin from "@/pages/Admin";
import WeeklyMenu from "@/pages/WeeklyMenu";
import SuggestRecipe from "@/pages/SuggestRecipe";
import AskPapi from "@/components/AskPapi";
import Hub from "@/pages/Hub";
import CalEntrar from "@/pages/calendar/CalEntrar";
import CalHoy from "@/pages/calendar/CalHoy";
import CalMes from "@/pages/calendar/CalMes";
import CalPerfil from "@/pages/calendar/CalPerfil";
import CalAdmin from "@/pages/calendar/CalAdmin";
import { CalAuthProvider } from "@/lib/calAuth";
import { CalProtected } from "@/components/calendar/CalLayout";

function Protected({ children }) {
  const { token, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-cocoa">Cargando…</div>;
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

// Botón flotante visible en todas las pantallas autenticadas (no en /login).
// Si estás dentro de una receta o modo cocina, le pasa el slug para dar contexto.
function GlobalAskPapi() {
  const { token } = useAuth();
  const loc = useLocation();
  if (!token) return null;
  if (loc.pathname === "/" || loc.pathname.startsWith("/login") || loc.pathname.startsWith("/calendario")) return null;
  // Try to detect slug from URL (/receta/:slug or /cocinar/:slug)
  const m = loc.pathname.match(/^\/(?:receta|cocinar)\/([^/]+)/);
  const slug = m ? decodeURIComponent(m[1]) : null;
  return <AskPapi slug={slug} variant="fab" />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <CalAuthProvider>
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Hub />} />
          <Route path="/cocina" element={<Protected><Home /></Protected>} />
          <Route path="/calendario/entrar" element={<CalEntrar />} />
          <Route path="/calendario" element={<CalProtected><CalHoy /></CalProtected>} />
          <Route path="/calendario/mes" element={<CalProtected><CalMes /></CalProtected>} />
          <Route path="/calendario/perfil" element={<CalProtected><CalPerfil /></CalProtected>} />
          <Route path="/calendario/admin" element={<CalAdmin />} />
          <Route path="/receta/:slug" element={<Protected><Recipe /></Protected>} />
          <Route path="/cocinar/:slug" element={<Protected><Cook /></Protected>} />
          <Route path="/agregar" element={<Protected><AddRecipe /></Protected>} />
          <Route path="/menus" element={<Protected><Menus /></Protected>} />
          <Route path="/menu/:id" element={<Protected><MenuDetail /></Protected>} />
          <Route path="/galeria" element={<Protected><Gallery /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="/menu-semanal" element={<Protected><WeeklyMenu /></Protected>} />
          <Route path="/sugerir" element={<Protected><SuggestRecipe /></Protected>} />
        </Routes>
        <GlobalAskPapi />
      </BrowserRouter>
      </CalAuthProvider>
    </AuthProvider>
  );
}
